"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.status.pending': 'In Attesa',
    'payment.status.success': 'Successo',
    'payment.status.rejected': 'Rifiutato',
    'payment.status.error': 'Errore',
    'payment.status.unknown': 'Sconosciuto',
};
